<template>
  <Checkbox v-bind="$attrs" v-on="$listeners" :class="{ otherClass: showOtherClass }">
    <slot>{{ text }}</slot>
  </Checkbox>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { Checkbox } from 'element-ui'

defineProps({
  text: [String, Number],
  //为了区分本身的class
  showOtherClass: {
    type: Boolean,
    default: false,
  },
})
</script>
<style lang="scss">
@import '../style/checkbox.scss';
</style>
